// import { storeAsync } from '@/app-module';
// const store = storeAsync();
// import { getLanguages, setLanguageCode } from '@/i18n';
// const languages = getLanguages().map(lang => lang.id)
// console.log('languages : ', languages)
// import i18n from '@/vueI18n'


export default {
  async beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.unauth) {
      next();
      return;
    }

   
    // debugger
    if (to.path.includes('/__/auth/custom-handler/action')) {
        // Get the action to complete.
        const mode = to.query.mode
        // // Get the one-time code from the query parameter.
        // const actionCode = to.query.actionCode
        // // (Optional) Get the continue URL from the query parameter if available.
        // const continueUrl = to.query.continueUrl
        // (Optional) Get the language code if available.
        // const lang = to.query.lang || 'en';

        if (mode === 'resetPassword' || mode === 'recoverEmail' || mode === 'verifyEmail') {
            // setLanguageCode(lang)
            // storeAsync().dispatch('saryahLanding/landing/changeCurrentLanguageCode', lang);
            // i18n.locale = lang;
            
            // if (languages.indexOf(lang) != -1) {
            //     if (localStorage.getItem('language') !== lang) {
            //         setLanguageCode(lang)
            //         storeAsync().dispatch('saryahLanding/landing/changeCurrentLanguageCode', lang);
            //     }
            //     i18n.locale = lang;
            //     return next()
            // } 
            // lang = localStorage.getItem('language') || 'ar' 
            // i18n.locale = lang;
            // const path = to.params.lang ? to.path.replace(to.params.lang, lang) : lang
            // return next({ path: path })

            return next();
        } else {
            return next('/invalid-Mode');
        }
    } else {
      return next();
    }

  },
};
